// extracted by mini-css-extract-plugin
export default {"center":"BackgroundLayout_center__y-rEl","content":"BackgroundLayout_content__wP0Pe","children":"BackgroundLayout_children__auzGT"};